import axios from 'axios';

export const API_URL = "https://shopnexgen-multi-vendor-app.onrender.com";

export const api = axios.create({
  baseURL: API_URL, 
  headers: {
    'Content-Type': 'application/json',
  },
});
